import { Row, Col, FormGroup, Input } from "reactstrap"

import { CustomAutocomplete } from "common"
import { FormControl, Grid, TextField } from "@mui/material"

const ModalFormCash = ({useFetchInit}) => {

    const {
        //------------- globalStates
        globalStates,
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,

    } = useFetchInit

    const { modalOpeningMode } = globalStates

    const { fetchAllCashRegisters } = FetchData
    const { cashRegisters } = fetchAllCashRegisters


    const { FormDeposit } = Forms
    const { formState, onInputChange,  onSelectSearchChange } = FormDeposit

    return (
        <div className='content'>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ marginBottom: 2, marginTop: 2 }}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <FormControl fullWidth>
                        <label htmlFor="idcaja">* Caja</label>
                        <CustomAutocomplete 
                                customId="idcaja"
                                customName="idcaja"
                                customValue={formState.idcaja}
                                customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idcaja', value: value.value }})}
                                customPlaceholder='Seleccionar caja'
                                customOptions={
                                    cashRegisters.map(({ idcaja, descripcion_corta }) => ({
                                        value: idcaja,
                                        name: descripcion_corta
                                    }))
                                }
                                customDisableClearable={true}
                                customDisabled={(modalOpeningMode === 'READONLY') ? true : false}
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <FormControl fullWidth> 
                        <label htmlFor="deposito_observaciones">Observaciones</label>
                        <TextField
                            id='deposito_observaciones'
                            name='deposito_observaciones'
                            size='small'
                            hiddenLabel
                            multiline
                            rows={5}
                            value={ formState.deposito_observaciones }
                            onChange={ onInputChange }
                            placeholder='Observaciones'
                            variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                            InputProps={{
                                readOnly: (modalOpeningMode === 'READONLY') ? true : false
                            }}
                            type='text'
                        />
                    </FormControl>
                </Grid> 
            </Grid>
        </div>

    )
}

export{
    ModalFormCash
}